const PLACEHOLDER_HOSTS = new Set(["seudominio.com.br", "www.seudominio.com.br"]);

function clean(value) {
  return String(value ?? "").trim().replace(/\/$/, "");
}

export function resolveApiUrl(configuredValue, locationLike) {
  const configured = clean(configuredValue);
  if (configured) {
    try {
      const parsed = new URL(configured);
      if (!PLACEHOLDER_HOSTS.has(parsed.hostname.toLocaleLowerCase("pt-BR"))) return configured;
    } catch {
      // Um valor inválido ou antigo é substituído pelo endereço do site publicado.
    }
  }

  const protocol = locationLike?.protocol ?? "";
  const origin = clean(locationLike?.origin);
  const hostname = String(locationLike?.hostname ?? "").toLocaleLowerCase("pt-BR");
  if ((protocol === "https:" || protocol === "http:") && origin && hostname && hostname !== "localhost" && hostname !== "127.0.0.1") {
    return `${origin}/api`;
  }
  return "";
}
